// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { CategoryModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

export type FeaturedCategoriesStateModel = {
    view: {
        [key: string]: {
            categories: CategoryModel[];
            isLoading: boolean;
        };
    };
};

const initialState: FeaturedCategoriesStateModel = {
    view: {},
};

const xFeaturedCategoriesData = createTypedReducerWithImmer(initialState, {
    "xFeaturedCategories/CompleteLoad": (draft: Draft<FeaturedCategoriesStateModel>, action: { key: string }) => {
        draft.view[action.key].isLoading = false;
    },
    "xFeaturedCategories/setLoading": (draft: Draft<FeaturedCategoriesStateModel>, action: { key: string }) => {
        draft.view[action.key] = {
            categories: [],
            isLoading: true,
        };
    },
    "xFeaturedCategories/loadCategories": (
        draft: Draft<FeaturedCategoriesStateModel>,
        action: { categories: CategoryModel[]; key: string },
    ) => {
        if (!draft.view[action.key]) {
            draft.view[action.key] = {
                categories: [],
                isLoading: true,
            };
        }
        draft.view[action.key].categories = action.categories;
    },
});

(reducers as any).xFeaturedCategoriesData = xFeaturedCategoriesData;

export type xFeaturedCategoriesData = {
    xFeaturedCategoriesData: FeaturedCategoriesStateModel;
} & ApplicationState;

type FeaturedCategoriesDataReducer = {
    featuredCategoriesData: typeof xFeaturedCategoriesData;
};

export type FeaturedCategoriesDataActions =
    | Parameters<FeaturedCategoriesDataReducer[keyof FeaturedCategoriesDataReducer]>[1]
    | AnyAction;
